// removed by extract-text-webpack-plugin
module.exports = {"deviceInfoTab5":"_2EEMFikyxDwnl2_iXmlEJf","text":"_1jlCFKj1PGayPD7sMGFRha","textValue":"_3sNWViCJeO42zH3I3n7rZM","afterConnectContainer":"_3nDBIzRnybfwAix_BgunT0","inputNumbner":"_1nd1jauXPyrCsEf3R2GeGR","connectBtn":"_1J4nx6_BmsS2JRiIlMQgj1"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DeviceInfo/DeviceConnect.less
// module id = 1592
// module chunks = 0